export const itdevcontact = 'mailto:itdevelopment_dir@uams.edu?subject=Clinical Skills Leaderboards';
